interface Props {
    text: string;
    label?: string;
}

export function TextValueContainer({ label, text }: Props) {
    return (
        <div>
            {label && (
            <label className="text-sm font-semibold">{label}</label>
            )}
            <input
                disabled
                value={text}
                className="w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                font-semibold text-gray-600 text-sm"/>
        </div>
    );
}
